module.exports = __webpack_public_path__ + "logo-big.png?6ee89bbf711fbfb415d0cd5e5c72b833";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-big.png
// module id = 31
// module chunks = 0